<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="formObserver">
    <b-form
      v-if="request"
      @keypress.enter.prevent
      @submit.prevent="handleSubmit(send())"
    >
      <!-- LOCALISATION DU SITE CONCERNE PAR LA DEMANDE -->
      <div class="block-flat">
        <div class="header">
          <h3>Localisation du site concerné par la demande</h3>
        </div>

        <div class="block-content">
          <fieldset>
            <autocomplete
              placeholder="Rechercher une adresse..."
              :source="getApi()"
              input-class="form-control"
              @selected="selectedAddress($event)"
              results-property="features"
              :results-display="formattedDisplay"
            >
              <template v-slot:noResults> Pas de résultat</template>
            </autocomplete>
            <b-alert show variant="info" class="no-margin-bottom mt-3">
              Utilisez les boutons à gauche, dans la carte pour schématiser
              l'emprise des travaux (saisit automatique des parcelles).<br />
              Vous pouvez affiner la position du chantier en déplacant le
              marqueur.
            </b-alert>
            <div id="container-map">
              <maps
                :draw="true"
                @pointMoved="pointMoved($event)"
                @featuresDrawed="finishdraw($event)"
                :vectorLayers="vectorLayers"
                width="calc(100%)"
              ></maps>
            </div>
          </fieldset>
          <fieldset>
            <div>
              <p
                v-if="
                  (request.theGeom == null ||
                    request.theGeom.geometries.length == 0) &&
                    request.stateId != 8
                "
                style="color: red; text-align: center"
              >
                <b
                  >Merci de schématiser l'emprise des travaux avec la carte,
                  sans quoi l'instruction ne pourra être réalisée</b
                >
              </p>
            </div>
            <legend>Adresse principale</legend>
            <div class="form-group">
              <b-row>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Numéro :</label>
                </b-col>
                <b-col lg="2" md="9" sm="12" cols="12">
                  <b-input
                    v-model="request.addressNum"
                    placeholder="Numéro"
                  ></b-input>
                </b-col>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Extension :</label>
                </b-col>
                <b-col lg="2" md="9" sm="12" cols="12">
                  <b-input
                    v-model="request.addressExt"
                    placeholder="Extension"
                  ></b-input>
                </b-col>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">
                    Type de voie<span class="red">*</span> :
                  </label>
                </b-col>
                <b-col lg="2" md="9" sm="12" cols="12">
                  <b-form-select
                    v-model="request.addressType"
                    placeholder="Type de voie"
                    required
                    :options="typesVoies"
                  ></b-form-select>
                </b-col>
                <!--<b-col lg="12" md="12" sm="12" cols="12" class="no-padding"></b-col>-->
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">
                    Nom de voie :<span class="red">*</span>
                  </label>
                </b-col>
                <b-col lg="4" md="3" sm="12" cols="12">
                  <b-input
                    v-model="request.addressName"
                    placeholder="Nom de la voie"
                    required
                  ></b-input>
                  <!-- En fonction du type de voie rapprochez vous de l'autorité en question -->
                  <p
                    v-if="
                      request.wayType !== null &&
                        request.wayType !== 'Voie communale' &&
                        request.wayType !==
                          'Voie departementale en agglomeration' &&
                        request.wayType !== 'VPC ZA MACS' &&
                        request.wayType !== 'Voie Verte'
                    "
                    style="color: red; text-align: center"
                  >
                    Ce type de voie : <b>"{{ request.wayType }}"</b> ne fait pas
                    partie de la gestion de MACS. <br />Veuillez vérifier la
                    localisation du chantier.
                  </p>
                  <p
                    v-if="noRoad == true"
                    style="color: red; text-align: center"
                  >
                    Aucune voie trouvée <br />Veuillez vérifier la localisation
                    du chantier.
                  </p>
                </b-col>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Lieu-dit ou BP :</label>
                </b-col>
                <b-col lg="4" md="3" sm="12" cols="12">
                  <b-input
                    v-model="request.place"
                    placeholder="Lieu-dit ou boite postale"
                  ></b-input>
                </b-col>
                <!--<b-col lg="12" md="12" sm="12" cols="12" class="no-padding"></b-col>-->
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">
                    Localité<span class="red">*</span> :
                  </label>
                </b-col>
                <b-col lg="6" md="9" sm="12" cols="12">
                  <b-form-select
                    v-model="request.addressCity"
                    placeholder="Localité"
                    required
                    :options="macsCities"
                  ></b-form-select>
                  <p
                    v-if="
                      request.addressCity !== null &&
                        !macsCities.includes(request.addressCity)
                    "
                    style="color: red; text-align: center"
                  >
                    <b>{{ request.addressCity }}</b> ne fait pas partie de MACS.
                  </p>
                </b-col>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">
                    Code postal<span class="red">*</span> :
                    </label>
                </b-col>
                <b-col lg="2" md="9" sm="12" cols="12">
                  <b-input
                    v-model="request.addressPostalCode"
                    placeholder="Code Postal"
                    required
                  ></b-input>
                </b-col>
              </b-row>
            </div>
            <div class="form-group">
              <b-row>
                <b-col lg="12" md="12" sm="12" cols="12">
                  <label class="marginTop"><b>Référence cadastrale :</b></label>
                </b-col>

                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label clearfix">
                    Parcelle(s) :<span class="red">*</span>
                  </label>
                </b-col>
                <b-col lg="4" md="3" sm="12" cols="12">
                  <b-input
                    v-model="request.plotNumbers"
                    placeholder="Parcelle(s)"
                    required
                  ></b-input>
                </b-col>
              </b-row>
            </div>
          </fieldset>
          <div class="text-center" v-if="request.type != 2">
            <b-button @click="addNewAdresse()" variant="success">
              Ajouter une adresse
              <font-awesome-icon icon="plus" class="ml-1"></font-awesome-icon>
            </b-button>
          </div>
          <fieldset v-if="request.adresses.length > 0">
            <legend>Adresse(s) secondaire(s)</legend>
            <div
              class="form-group"
              v-for="(secondary_addresse, index) in request.adresses"
              :key="index"
            >
              <b-row>
                <b-col lg="11">
                  <b-row>
                    <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                      <label class="control-label">Numéro :</label>
                    </b-col>
                    <b-col lg="2" md="9" sm="12" cols="12">
                      <b-input
                        v-model="secondary_addresse.addressNum"
                        placeholder="Numéro"
                      ></b-input>
                    </b-col>
                    <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                      <label class="control-label">Extension :</label>
                    </b-col>
                    <b-col lg="2" md="9" sm="12" cols="12">
                      <b-input
                        v-model="secondary_addresse.addressExt"
                        placeholder="Extension"
                      ></b-input>
                    </b-col>
                    <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                      <label class="control-label">
                        Type de voie<span class="red">*</span> :
                      </label>
                    </b-col>
                    <b-col lg="2" md="9" sm="12" cols="12">
                      <b-form-select
                        v-model="secondary_addresse.addressType"
                        placeholder="Type de voie"
                        required
                        :options="typesVoies"
                      ></b-form-select>
                    </b-col>
                    <!--<b-col lg="12" md="12" sm="12" cols="12" class="no-padding"></b-col>-->
                    <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                      <label class="control-label">
                        Nom de voie :<span class="red">*</span>
                      </label>
                    </b-col>
                    <b-col lg="4" md="3" sm="12" cols="12">
                      <b-input
                        v-model="secondary_addresse.addressName"
                        placeholder="Nom de la voie"
                        required
                      ></b-input>
                    </b-col>
                    <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                      <label class="control-label">Lieu-dit ou BP :</label>
                    </b-col>
                    <b-col lg="4" md="3" sm="12" cols="12">
                      <b-input
                        v-model="secondary_addresse.place"
                        placeholder="Lieu-dit ou boite postale"
                      ></b-input>
                    </b-col>
                    <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                      <label class="control-label">
                        Localité<span class="red">*</span> :
                      </label>
                    </b-col>
                    <b-col lg="6" md="9" sm="12" cols="12">
                      <b-form-select
                        v-model="secondary_addresse.addressCity"
                        placeholder="Localité"
                        required
                        :options="macsCities"
                      ></b-form-select>
                    </b-col>
                    <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                      <label class="control-label">
                        Code postal<span class="red">*</span> :
                      </label>
                    </b-col>
                    <b-col lg="2" md="9" sm="12" cols="12">
                      <b-input
                        v-model="secondary_addresse.addressPostalCode"
                        placeholder="Code Postal"
                        required
                      ></b-input>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col
                  lg="1"
                  style="display: flex;justify-content: center;align-items: center;"
                >
                  <b-button @click="removeAddress(index)">
                    <font-awesome-icon icon="trash" />
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </fieldset>
          <fieldset>
            <legend>Projet</legend>
            <div class="form-group">
              <b-row>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label clearfix">
                    <span v-b-tooltip.hover title="Résumé du projet">
                      <font-awesome-icon icon="question-circle"></font-awesome-icon>
                    </span>
                    Objet du projet :
                  </label>
                </b-col>
                <b-col lg="6" md="3" sm="12" cols="12">
                  <b-form-input
                    v-model="request.project"
                    placeholder="..."
                  ></b-form-input>
                </b-col>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label clearfix">
                    <span v-b-tooltip.hover title="Numéro d'affaire">
                      <font-awesome-icon icon="question-circle"></font-awesome-icon>
                    </span>
                    Numéro d'affaire :
                  </label>
                </b-col>
                <b-col lg="2" md="3" sm="12" cols="12">
                  <b-form-input
                    v-model="request.numaffaire"
                    placeholder="..."
                  ></b-form-input>
                </b-col>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label clearfix">
                    Numéro de référence :
                  </label>
                </b-col>
                <b-col lg="3" md="3" sm="12" cols="12">
                  <b-form-input
                    v-model="request.reference"
                    placeholder="ex : PC06499923X001"
                  ></b-form-input>
                </b-col>
              </b-row>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="stepper-control">
        <b-button
          type="submit"
          :disabled="!SuivantShow"
          variant="warning"
          class="marginBottom-15"
        >
          <span>Suivant </span>
          <font-awesome-icon
            icon="caret-right"
            class="marginLeft-5"
          ></font-awesome-icon>
        </b-button>
      </div>
    </b-form>
  </ValidationObserver>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import _ from "underscore";
import maps from "../../components/Maps.vue";
import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Icon from "ol/style/Icon";
import Text from "ol/style/Text";
import Point from "ol/geom/Point";
import Feature from "ol/Feature";
import MultiPolygon from "ol/geom/MultiPolygon";
import MultiLineString from "ol/geom/MultiLineString";
import MultiPoint from "ol/geom/MultiPoint";
import ChoixCerfa from "./ChoixCerfa.vue";

export default {
  async mounted() {
    if (this.add == false) {
      this.SuivantShow = true;
      this.addressSelected = this.point;
      window.Event.$emit("locatePoint", this.addressSelected);
      if (
        this.features &&
        this.features[0] &&
        this.features[0].geometry &&
        this.features[0].geometry.geometries
      ) {
        this.features[0].geometry.geometries.forEach(function(element) {
          let geom;

          switch (element.type) {
            case "MultiPolygon":
              geom = new MultiPolygon(element.coordinates);
              break;
            case "MultiLineString":
              geom = new MultiLineString(element.coordinates);
              break;
            case "MultiPoint":
              geom = new MultiPoint(element.coordinates);
              break;
          }
          let feature = new Feature({ geometry: geom });

          window.Event.$emit("AddDrawnFeature", feature);
        });
      }
    }
    if (this.add == true) {
      this.request.lon = this.point.geometry.coordinates[0];
      this.request.lat = this.point.geometry.coordinates[1];
      this.addressSelected = [this.point];
      window.Event.$emit("locatePoint", this.addressSelected);
    }
  },
  props: ["add"],

  data: () => ({
    noRoad: false,
    SuivantShow: false, // Sert à griser le btn suivant si ce n'est pas une voie pour gestion macs
    optionsOuiNonAgglo: [
      { text: "Oui", value: true },
      { text: "Non", value: false },
    ],
    macsCities: [
      "Angresse",
      "Azur",
      "Bénesse-Maremne",
      "Capbreton",
      "Josse",
      "Labenne",
      "Magescq",
      "Messanges",
      "Moliets-et-Maa",
      "Orx",
      "Saint-Geours-de-Maremne",
      "Saint-Jean-de-Marsacq",
      "Sainte-Marie-de-Gosse",
      "Saint-Martin-de-Hinx",
      "Saint-Vincent-de-Tyrosse",
      "Saubion",
      "Saubrigues",
      "Saubusse",
      "Seignosse",
      "Soorts-Hossegor",
      "Soustons",
      "Tosse",
      "Vieux-Boucau-les-Bains",
    ],
    wayTypes: [
      // A voir si MACS ne se focus que sur ce type de voie
      { value: "VPC ZA MACS", text: "VPC ZA MACS" },
      {
        value: "Voie departementale en agglomeration",
        text: "Voie departementale en agglomeration",
      },
      {
        value: "Voie communale",
        text: "Voie communale",
      },
    ],
    addressSelected: [],
    addressSearch: "",
    type_voie: [
      "allée",
      "allee",
      "avenue",
      "boulevard",
      "carrefour",
      "chemin",
      "chaussée",
      "chaussee",
      "cité",
      "cite",
      "corniche",
      "cours",
      "domaine",
      "descente",
      "ecart",
      "esplanade",
      "faubourg",
      "grande",
      "grande-rue",
      "hameau",
      "halle",
      "halles",
      "impasse",
      "lieu-dit",
      "lieu",
      "lotissement",
      "marché",
      "marche",
      "montée",
      "montee",
      "passage",
      "place",
      "plaine",
      "plateau",
      "promenade",
      "parvis",
      "quartier",
      "quai",
      "residence",
      "résidence",
      "rue",
      "ruelle",
      "rocade",
      "rond",
      "rond-point",
      "route",
      "sente",
      "sentier",
      "sente-sentier",
      "sentier-sente",
      "square",
      "terre",
      "terre-plein",
      "traverse",
      "villa",
      "village",
    ],
    typesVoies: [
      "Allée",
      "Avenue",
      "Boulevard",
      "Carrefour",
      "Chemin",
      "Chaussée",
      "Cité",
      "Corniche",
      "Cours",
      "Domaine",
      "Descente",
      "Ecart",
      "Esplanade",
      "Faubourg",
      "Grande-rue",
      "Hameau",
      "Halle",
      "Halles",
      "Impasse",
      "Lieu-dit",
      "Lotissement",
      "Marché",
      "Montée",
      "Passage",
      "Place",
      "Plaine",
      "Plateau",
      "Promenade",
      "Parvis",
      "Quartier",
      "Quai",
      "Résidence",
      "Rue",
      "Ruelle",
      "Rocade",
      "Rond-point",
      "Route",
      "Sente",
      "Sentier",
      "Square",
      "Terre",
      "Terre-plein",
      "Traverse",
      "Villa",
      "Village",
    ],
  }),
  methods: {
    removeAddress(index) {
      this.request.adresses.splice(index, 1);
    },
    addNewAdresse() {
      this.request.adresses.push({
        addressNum: null,
        addressName: null,
        addressType: null,
        addressCity: null,
        addressPostalCode: null,
        prescription: null,
      });
    },
    previous() {
      this.$emit("previous");
    },
    send() {
      this.$refs.formObserver.validate().then((success) => {
        if (
          (this.request.theGeom == null ||
            this.request.theGeom.geometries.length == 0) &&
          this.request.stateId != 8
        ) {
          this.$emit(
            "error",
            "Merci de schématiser l'emprise des travaux avec la carte, sans quoi l'instruction ne pourra être réalisée"
          );
        } else if (success == true) {
          this.$emit("submit");
        } else {
          this.$emit("error", "Veuillez corriger les erreurs du formulaire");
        }
      });
    },

    ...Vuex.mapActions("Perimeter", ["getPerimeters"]),
    ...Vuex.mapActions("Dossiers", ["setDossier"]),

    async getPlotsSections(dep, geom) {
      return new Promise((resolve, reject) => {
        var myHeaders = new Headers({
          Authorization: "Bearer " + window.$cookies.get("token-sudthd"),
        });
        fetch(window.urlapi + "plots", {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({ dep: dep, geom: geom }),
        })
          .then((res) => res.json())
          .then((res) => {
            this.request.plotNumbers = res.data.plots;
            this.request.sections = res.data.sections;
          });
      });
    },

    async getTroncon(geom) {
      return new Promise((resolve, reject) => {
        var myHeaders = new Headers({
          Authorization: "Bearer " + window.$cookies.get("token-sudthd"),
        });
        fetch(window.urlapi + "troncon", {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({ geom: geom }),
        })
          .then((res) => res.json())
          .then((res) => {
            if (res.data == false) {
              this.SuivantShow = false;
              this.noRoad = true;
            } else if (res.data && res.data.typevoie != null) {
              this.noRoad = false;
              this.request.wayType = res.data.typevoie;
              if (
                this.request.wayType == "Voie departementale en agglomeration"
              ) {
                this.request.inUrban = true;
              } else {
                this.request.inUrban = false;
              }

              if (
                this.request.wayType !== "Voie communale" &&
                this.request.wayType !==
                  "Voie departementale en agglomeration" &&
                this.request.wayType !== "VPC ZA MACS" &&
                this.request.wayType !== 'Voie Verte'
              ) {
                this.SuivantShow = false;
              } else {
                this.SuivantShow = true;
              }
            }
          });
      });
    },

    async pointMoved(coordinates) {
      this.request.lon = coordinates[0];
      this.request.lat = coordinates[1];
      // version deplacement
      this.request.operationCode = await this.getCodeOperateur(
        this.request.lon,
        this.request.lat
      );
      window.Event.$emit("locatePoint", this.request);

      // version geocodage
      fetch(
        window.ADDRESSREVERSEAPI +
          "?lon=" +
          coordinates[0] +
          "&lat=" +
          coordinates[1]
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.features[0]) {
            let addressSelected = res.features[0];
            // this.addressSelected = Object.freeze([addressSelected]);
            this.request.addressNum = addressSelected.properties.housenumber;
            this.request.addressExt = this.getExtension(
              addressSelected.properties.housenumber
            );
            this.request.addressType = this.getTypeVoie(addressSelected)[
              "type"
            ];
            this.request.addressName = this.getTypeVoie(addressSelected)[
              "voie"
            ];
            this.request.addressCity = addressSelected.properties.city;
            this.request.addressPostalCode =
              addressSelected.properties.postcode;
            // this.request.lon = addressSelected.geometry.coordinates[0];
            // this.request.lat = addressSelected.geometry.coordinates[1];
            // window.Event.$emit("locatePoint", this.request);
          }
        });
      //   this.request.operationCode = await this.getCodeOperateur(
      //     this.request.lon,
      //     this.request.lat
      //   );
    },
    async getOperator() {
      //operatorPerimeterId
      let search = {
        lon: this.request.lon,
        lat: this.request.lat,
        type: "operator",
      };
      this.operators = await this.getPerimeters(search);
      if (this.operators.length == 0) {
        this.request.showComboOperator = true;
        this.request.operatorPerimeterId = null;
        this.request.operator = null;
        this.request.queryOperator = "perimeter?limit=10&type=operator&q=";
      } else if (this.operators.length >= 1) {
        this.request.showComboOperator = true;
        this.request.operatorPerimeterId = null;
        this.request.operator = null;
        this.request.queryOperator =
          "perimeter?limit=10&type=operator&lon=" +
          this.request.lon +
          "&lat=" +
          this.request.lat +
          "&q=";
      }
      // } else {
      //   if (this.operators[0]) {
      //     this.request.operatorPerimeterId = this.operators[0].id;
      //     this.request.operator = this.operators[0];
      //     this.request.showComboOperator = true;
      //   }
      // }
    },
    async getCodeOperateur(lon, lat) {
      if (
        this.userConnected &&
        !this.userConnected.roles.includes("ROLE_USER")
      ) {
        await this.getOperator();
      }
      return new Promise((resolve, reject) => {
        var myHeaders = new Headers({
          Authorization: "Bearer " + window.$cookies.get("token-sudthd"),
        });

        fetch(window.urlapi + "zone", {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({ lon: lon, lat: lat }),
        })
          .then((res) => res.json())
          .then((res) => {
            if (res.data != null) {
              resolve(res.data.code_ope);
            } else {
              resolve(null);
            }
          });
      });
    },
    formattedDisplay(result) {
      return (
        result.properties.name +
        ", <b>" +
        result.properties.postcode +
        " " +
        result.properties.city +
        "</b>"
      );
    },
    getApi() {
      return window.ADDRESSAPI;
    },
    retourValue(array, depart) {
      let retour = "";
      for (let i = depart; i < array.length; i++) {
        if (retour != "") retour += " ";
        retour += array[i];
      }
      return retour;
    },
    getTypeVoie(data) {
      let chaine;
      if (data.properties.street !== undefined) {
        chaine = data.properties.street;
      } else {
        chaine = data.properties.name;
      }

      var find = false;
      var retour = [];

      var arrSplit = chaine.split(" ");
      if (arrSplit.length > 1) {
        if (this.type_voie.indexOf(arrSplit[0].toLowerCase()) >= 0) {
          var temp0 = arrSplit[0].toLowerCase();
          var temp1 = arrSplit[1].toLowerCase();
          switch (temp0) {
            case "grande":
              if (temp1 == "rue") {
                retour["type"] = "Grande-Rue";
                if (arrSplit.length == 2) retour["voie"] = "Grande-Rue";
                else retour["voie"] = this.retourValue(arrSplit, 2);
                find = true;
              }
              break;
            case "lieu":
              if (temp1 == "dit") {
                retour["type"] = "Lieu-dit";
                retour["voie"] = this.retourValue(arrSplit, 2);
                find = true;
              }
              break;
            case "rond":
              if (temp1 == "point") {
                retour["type"] = "Rond-Point";
                retour["voie"] = this.retourValue(arrSplit, 2);
                find = true;
              }
              break;
            case "sente":
              if (temp1 == "sentier") {
                retour["lieu-dit"] = "Sente-Sentier";
                retour["voie"] = this.retourValue(arrSplit, 2);
              } else {
                retour["type"] = "Sente";
                retour["voie"] = this.retourValue(arrSplit, 1);
              }
              find = true;
              break;
            case "sentier":
              if (temp1 == "sente") {
                retour["lieu-dit"] = "Sente-Sentier";
                retour["voie"] = this.retourValue(arrSplit, 2);
              } else {
                retour["type"] = "Sentier";
                retour["voie"] = this.retourValue(arrSplit, 1);
              }
              find = true;
              break;
            case "terre":
              if (temp1 == "plein") {
                retour["type"] = "Terre-plein";
                retour["voie"] = this.retourValue(arrSplit, 2);
                find = true;
              }
              break;
            default:
              retour["type"] = arrSplit[0];
              retour["voie"] = this.retourValue(arrSplit, 1);
              find = true;
              break;
          }
        }
      }
      if (!find) {
        retour["type"] = "Lieu-dit";
        retour["voie"] = chaine;
      }

      return retour;
    },
    getExtension(housenumber) {
      let retour;
      if (housenumber !== undefined) {
        if (housenumber.indexOf(" ") !== -1) {
          arrSplit = housenumber.split(" ");
          retour = arrSplit[1];
        } else {
          retour = "";
        }
      } else {
        retour = "";
      }
      return retour;
    },
    async selectedAddress(result) {
      let addressSelected = result.selectedObject;
      this.addressSelected = Object.freeze([addressSelected]);

      this.request.addressNum = addressSelected.properties.housenumber;
      this.request.addressExt = this.getExtension(
        addressSelected.properties.housenumber
      );
      this.request.addressType = this.getTypeVoie(addressSelected)["type"];
      this.request.addressName = this.getTypeVoie(addressSelected)["voie"];
      this.request.addressCity = addressSelected.properties.city;
      this.request.addressPostalCode = addressSelected.properties.postcode;
      this.request.lon = addressSelected.geometry.coordinates[0];
      this.request.lat = addressSelected.geometry.coordinates[1];
      this.request.operationCode = await this.getCodeOperateur(
        this.request.lon,
        this.request.lat
      );

      window.Event.$emit("locatePoint", this.request);
    },
    //TODO: amelioré la construction du json
    finishdraw(features) {
      let tab = [];
      features.forEach((feature) => {
        tab.push(feature.geometry);
      });
      let obj = {
        type: "GeometryCollection",
        geometries: tab,
      };
      this.request.theGeom = obj;
      if (
        this.request.addressPostalCode != null &&
        this.request.addressPostalCode != ""
      ) {
        this.getPlotsSections(
          this.request.addressPostalCode.substr(0, 2),
          this.request.theGeom
        );
        //Recupere automatiquement le type de voie et si en agglo ou non.
        this.getTroncon(this.request.theGeom);
      }
    },
  },
  name: "Localisation",
  components: {
    maps: maps,
  },

  computed: {
    request: {
      get: function() {
        return this.dossierSelected;
      },
      set: function(newValue) {
        this.setDossier(newValue);
      },
    },
    ...Vuex.mapGetters("Dossiers", ["dossierSelected", "features", "point"]),
    ...Vuex.mapGetters("Authentification", ["userConnected", "token"]),
    vectorLayers() {
      let tab = [];

      tab.push({
        vectorZIndex: 200,
        ref: "dossierSelectedPointLayer",
        visible: true,
        movePoint: true,
        features: this.addressSelected,
        factory: function() {
          return (feature) => {
            return [
              new Style({
                zIndex: 150,
                image: new Icon({
                  src: require("../../img/google-marker.png"),
                  scale: 0.05,
                }),
              }),
            ];
          };
        },
        click: function(feature) {},
      });

      return tab;
    },
    milestoneEnd: {
      get() {
        return (
          (this.request.milestoneEnd1 &&
            this.request.milestoneEnd1 != "" &&
            this.request.milestoneEnd1 != null) ||
          (this.request.milestoneEnd2 &&
            this.request.milestoneEnd2 != "" &&
            this.request.milestoneEnd2 != null)
        );
      },
      set(value) {},
    },
    milestoneStart: {
      get() {
        return (
          (this.request.milestoneStart1 &&
            this.request.milestoneStart1 != "" &&
            this.request.milestoneStart1 != null) ||
          (this.request.milestoneStart2 &&
            this.request.milestoneStart2 != "" &&
            this.request.milestoneStart2 != null)
        );
      },
      set(value) {},
    },
  },
};
</script>
